module.exports = __webpack_public_path__ + "img/device_online.c205d1ef.gif";